<template>
  <div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span></label>
    <v-select v-if="carto_has_loaded" :items="items" v-model="current_champ.value" ref="field"
      @blur="$refs.field.validate()" :disabled="is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-select>
    <v-text-field v-else v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
      :disabled="current_champ.disabled"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-text-field>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["champ", "cp", "inscription", "mode", "is_disable"],
  data() {
    return {
      carto_has_loaded: false,
      current_champ: {},
      items: [],
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
  },
  methods: {
    async populateSelect() {
      try {
        const fetch = await axios.get(
          "https://apicarto.ign.fr/api/codes-postaux/communes/" + this.cp,
          { timeout: 2000 }
        );
        if (fetch.data && fetch.data.length > 0) {
          this.carto_has_loaded = true;
          this.items = fetch.data.map((item) => {
            return item.libelleAcheminement;
          });
        }
      } catch (error) {
        console.error("Timeout ou erreur lors de l'appel Apicarto", error);
        this.carto_has_loaded = false;
      }
    },
  },
  async created() {
    this.current_champ = this.champ;
    await this.populateSelect();
  },
};
</script>

<style lang="scss">
.v-autocomplete__content {
  max-height: 300px !important;
  min-height: auto !important;
}
</style>